export const COOKIE_STORAGE = {
  TOKEN: 'token',
  EXPIRY: 30,
};
